import { ListItemText, ListItemIcon, Badge, ListItemSecondaryAction, IconButton, ListItemButton } from "@mui/material";
import { useStyles } from "./Menu.styles";

type BadgedMenuItemProps = {
	keyPrefix: string;
	keyName: string;
	title: string;
	badgeList: Array<Record<string, any>>;
	badgeListKey: string;
	badgeListValue: string;
	selectedIndex?: string | number;
	onClick: (e: React.MouseEvent, key: string) => void;
	icon: React.ReactNode;
	linkSuffix?: string;
};
export const BadgedMenuItem = (props: BadgedMenuItemProps) => {
	const classes = useStyles(props);
	const {
		keyPrefix,
		keyName,
		badgeList,
		badgeListKey,
		badgeListValue,
		selectedIndex,
		onClick,
		icon,
		title,
		linkSuffix,
	} = props;
	let badgeValue = 0;
	if (keyName.includes(",")) {
		const keys = keyName.split(",").map(k => k.trim().toLowerCase());
		badgeValue = keys.reduce((acc, k) => {
			const badgeObject = badgeList.find(m => (k ? m[badgeListKey]?.toLowerCase() === k : m[badgeListKey] == null));
			return acc + (badgeObject ? badgeObject[badgeListValue] : 0);
		}, 0);
	} else {
		const badgeObject = badgeList.find((m) => m[badgeListKey]?.toLowerCase() === keyName?.toLowerCase());
		if (badgeObject) {
			badgeValue = badgeObject[badgeListValue];
		}
	}
	return (
		<ListItemButton
			className={classes.nested}
			key={`${keyPrefix}${keyName}`}
			selected={selectedIndex === `${keyPrefix}${keyName}`}
			onClick={(e) => onClick(e, `${keyPrefix}${linkSuffix ?? keyName}`)}
		>
			<ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
			<ListItemText primary={title} />
			<ListItemSecondaryAction className={classes.listItemSecondaryAction}>
				<IconButton edge="end" aria-label="comments">
					{badgeValue !== 0 && <Badge overlap="rectangular" badgeContent={badgeValue} color="error"></Badge>}
				</IconButton>
			</ListItemSecondaryAction>
		</ListItemButton>
	);
};
